var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"min-width":"1260px"},attrs:{"id":"app"}},[_c('router-view'),_c('AiAssistant')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }